import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { callbackEventReflectionManageAdd, callbackEventReflectionManageUpd, eventManageData, callbackSwitchConfigManageData } from "@/api/financial/backhaul";
import backhaul from "../mixins/backhaul";
import { serchSelect } from "@/mixins/index";
export default {
  mixins: [backhaul, serchSelect],
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        id: "",
        switch_id: "",
        original_event: '',
        custom_event_name: "",
        reflection_event: ""
      },
      eventManageDataList: [],
      rules: {
        switch_id: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        original_event: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        custom_event_name: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }],
        reflection_event: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true; //  await this.getcallbackSwitchConfigManageData()

                if (!_this.searchData.special_product_id || !_this.searchData.special_product_id.toString()) {
                  _this.searchData.special_product_id_all = _this.productsList.map(function (i) {
                    return i.id;
                  });
                } else {
                  _this.searchData.special_product_id_all = _this.searchData.special_product_id;
                }

                callbackSwitchConfigManageData(_objectSpread(_objectSpread({}, _this.searchData), {}, {
                  product_id: _this.searchData.special_product_id_all
                })).then(function (res) {
                  if (res.status == 200) {
                    _this.callbackSwitchConfigData = res.data; // this.total = res.data.total
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

                if (data) {
                  // let callbackSwitchConfigData = this.callbackSwitchConfigData.find(i=>i.)
                  _this.formData = _objectSpread({}, data);

                  _this.callbackSwitch(data.switch_id, false);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.formData.id = '';
      this.clearData();
    },
    callbackSwitch: function callbackSwitch(e) {
      var _this2 = this;

      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (type) {// this.formData.original_event = ''
        // this.eventManageDataList = []
      }

      if (e == "") {
        this.eventManageDataList = [];
        this.formData.original_event = "";
        return;
      }

      var data = this.callbackSwitchConfigData.find(function (i) {
        return i.id == e;
      });
      eventManageData({
        advert_channel_id: data.advert_channel_id
      }).then(function (res) {
        if (res.status == 200) {
          _this2.eventManageDataList = res.data;
        }
      });
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this3.formData.id ? callbackEventReflectionManageUpd : callbackEventReflectionManageAdd;
          req(_objectSpread({}, _this3.formData)).then(function (res) {
            if (res.status == 200) {
              _this3.$Message.success('操作成功');

              _this3.$emit("refreshDataList");

              _this3.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.formData = {
        id: this.formData.id,
        client_id: "",
        client_secret: '',
        advert_channel_id: ""
      };
      this.eventManageDataList = [];
      this.$refs.ruleForm.resetFields();
    }
  }
};